import { render } from "./FooterrCont.vue?vue&type=template&id=1a7c3289"
const script = {}

import "./FooterrCont.vue?vue&type=style&index=0&id=1a7c3289&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__